import { useGetGraphemePrimitiveRankQueryOptions } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.rank";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";

/**
 * Rank of `grapheme` among all decomposable graphemes by how often it is used as a component in the
 * user's script (PRC tiers or Taiwan MOE charts), read from the static DB. `null` while the query is
 * pending or when the grapheme has no component-prevalence rank for the active script.
 */
export function useGraphemePrimitiveRank(grapheme: string): number | null {
  const { data = null } = useQuery(useGetGraphemePrimitiveRankQueryOptions(grapheme));
  return data ?? null;
}
